module.exports = __webpack_public_path__ + "assets/img/Twitter.c9fb4d91.svg";